<div
  class="schedule-range-slider"
  [class.schedule-range-slider--has-wrapped]="wrappedHandles().size > 0"
>
  <div class="schedule-range-slider__track" #track>
    @for (segment of activeSegments(); track $index) {
      <span
        class="schedule-range-slider__selection"
        [style.left.%]="segment.left"
        [style.width.%]="segment.width"
      ></span>
    }
    <span
      class="schedule-range-slider__handle schedule-range-slider__handle--start"
      role="slider"
      tabindex="0"
      aria-label="Schedule start"
      aria-valuemin="0"
      [attr.aria-valuemax]="endMinutes()"
      [attr.aria-valuenow]="currentOffset()"
      [style.left.%]="startPercent()"
      [class.schedule-range-slider__handle--active]="activeHandle() === 'start'"
      (pointerdown)="onPointerDown($event, 'start')"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp()"
      (pointercancel)="onPointerUp()"
      (keydown)="onKeydown($event, 'start')"
    >
      <span
        #startBubble
        class="schedule-range-slider__bubble"
        [class.schedule-range-slider__bubble--wrapped]="wrappedHandles().has('start')"
        >{{ startLabel() }}</span
      >
    </span>
    @if (showsEndHandle()) {
      <span
        class="schedule-range-slider__handle schedule-range-slider__handle--end"
        role="slider"
        tabindex="0"
        aria-label="Schedule end"
        aria-valuemin="0"
        [attr.aria-valuemax]="periodLength()"
        [attr.aria-valuenow]="endMinutes()"
        [style.left.%]="endPercent()"
        [class.schedule-range-slider__handle--active]="activeHandle() === 'end'"
        (pointerdown)="onPointerDown($event, 'end')"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointercancel)="onPointerUp()"
        (keydown)="onKeydown($event, 'end')"
      >
        <span
          #endBubble
          class="schedule-range-slider__bubble"
          [class.schedule-range-slider__bubble--wrapped]="wrappedHandles().has('end')"
          >{{ endLabel() }}</span
        >
      </span>
    }
    @if (showsWrapHandle()) {
      <span
        class="schedule-range-slider__handle schedule-range-slider__handle--wrap"
        role="slider"
        tabindex="0"
        aria-label="Schedule end on the next day"
        aria-valuemin="0"
        [attr.aria-valuemax]="currentOffset()"
        [attr.aria-valuenow]="isWrapped() ? wrappedEnd() : 0"
        [attr.aria-valuetext]="wrapLabel()"
        [style.left.%]="wrapPercent()"
        [class.schedule-range-slider__handle--active]="activeHandle() === 'wrap'"
        (pointerdown)="onPointerDown($event, 'wrap')"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointercancel)="onPointerUp()"
        (keydown)="onKeydown($event, 'wrap')"
      >
        <span
          #wrapBubble
          class="schedule-range-slider__bubble"
          [class.schedule-range-slider__bubble--wrapped]="wrappedHandles().has('wrap')"
          >{{ wrapLabel() }}</span
        >
      </span>
    }
  </div>
</div>
